/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ngxElectronProxyFactory as ɵa} from './lib/renderer.module';